export default "__VITE_ASSET__a72985f5__"